export const DATA_FIRESTORE_V01_EVENT_ACTIVITY = {
  NAME: 'v01_event_activity',

  FIELDS: {
    VERSION: {
      KEY: 'v',
      DEFAULT: 1,
    },

    EVENT_ID: {
      KEY: 'eventId',
    },

    USER_ID: {
      KEY: 'userId',
    },

    USER_NAME: {
      KEY: 'userName',
    },

    USER_AVATAR: {
      KEY: 'userAvatar',
    },

    ACTION: {
      KEY: 'action',
    },

    DETAILS: {
      KEY: 'details',
    },

    TIMESTAMP: {
      KEY: 'timestamp',
    },

    IS_SYSTEM: {
      KEY: 'isSystem',
      DEFAULT: false,
    },
  },
}
